import React, { useContext, useState, useEffect } from "react";
import * as GrIcons from "react-icons/gr";
import * as FaIcons from "react-icons/fa";

import CreateCharterAssignments from "./CreateCharterAssignments";
import SearchUser from "./SearchUser";
import UserPermissionReview from "./UserPermissionReview";

import UserContext from "../../context/users/userContext";

const AddUserPermissionModal = () => {
  const userContext = useContext(UserContext);
  const {
    setFormModal,
    getSqlUsers,
    clearSqlUserResults,
    filterCharters,
    clearFilteredCharters,
    getCharters,
    createNewUserPermission,
  } = userContext;
  const [userText, setUserText] = useState("");
  const [charterText, setCharterText] = useState("");
  const [selectedUser, setSelectedUser] = useState({});
  const [selectedCharters, setSelectedCharters] = useState([]);
  const [showPermissionReview, setShowPermissionReview] = useState(false);
  const [showAddCharters, setShowAddCharters] = useState(false);
  const [permissionLevel, setPermissionLevel] = useState("");
  const [allCharterAccess, setAllCharterAccess] = useState(false);

  const userNotEmpty = Object.keys(selectedUser).length > 0;

  const readyForSubmission =
    (selectedCharters.length > 0 || permissionLevel === "Super Admin") &&
    !showAddCharters &&
    userNotEmpty &&
    permissionLevel !== "";

  const completedCharterSelection =
    userNotEmpty && showAddCharters && selectedCharters.length > 0;

  const handleOnUserTextChange = (e) => {
    if (e.target.value === "") {
      clearSqlUserResults();
    } else {
      getSqlUsers(e.target.value);
    }
    setUserText(e.target.value);
  };

  const handleOnCharterTextChange = (e) => {
    if (e.target.value === "") {
      clearFilteredCharters();
    } else {
      filterCharters(e.target.value);
    }
    setCharterText(e.target.value);
  };

  const handleAssignCharter = (item) => {
    if (selectedCharters.some((e) => e._id === item._id)) {
    } else {
      setSelectedCharters([...selectedCharters, item]);
    }
  };

  const handleRemoveCharter = (index) => {
    setSelectedCharters(selectedCharters.filter((char, key) => key !== index));
  };

  const emptySelectedUser = () => {
    setSelectedUser({});
    setCharterText("");
    setSelectedCharters([]);
    clearFilteredCharters();
    clearSqlUserResults();
    setUserText("");
  };

  const resetValues = () => {
    clearSqlUserResults();
    clearFilteredCharters();
    setUserText("");
    setCharterText("");
    setSelectedUser({});
    setSelectedCharters([]);
    setShowPermissionReview(false);
    setPermissionLevel("");
  };

  const handleConfirmAction = () => {
    if (completedCharterSelection) {
      setShowAddCharters(false);
    }
    if (readyForSubmission) {
      const newPermission = {
        name: `${selectedUser.FirstName} ${selectedUser.LastName}`,
        azureID: selectedUser.EmailAddress,
        charterAssignments: selectedCharters,
        userLevel:
          permissionLevel === "Admin"
            ? 3
            : permissionLevel === "User"
            ? 1
            : permissionLevel === "Contributor"
            ? 2
            : permissionLevel === "Super Admin"
            ? 4
            : 0,
        allCharterAccess,
        userStatus: permissionLevel,
        personDbID: selectedUser.PersonID,
      };
      createNewUserPermission(newPermission);
      console.log(newPermission);
      setFormModal("addUserPermissionModal", false);
    }
  };

  const handleOnPermissionChange = (e) => {
    if (e.target.value === "Super Admin") {
      setAllCharterAccess(true);
    } else {
      setAllCharterAccess(false);
    }
    setPermissionLevel(e.target.value);
  };

  const handleCancelReview = () => {
    setShowPermissionReview(false);
  };

  useEffect(() => {
    getCharters();
    return () => {
      resetValues();
    };
  }, []);

  return (
    <div id="add-user-permission-modal" className="modal">
      <div className="add-user-permission-content modal-content">
        <div className="top-bar">
          <GrIcons.GrFormClose
            className="close-icon"
            onClick={() => setFormModal("addUserPermissionModal", false)}
          />
          <h2>Create User Permission</h2>
        </div>
        <div className="modal-body">
          {userNotEmpty ? (
            showAddCharters ? (
              <CreateCharterAssignments
                selectedUser={selectedUser}
                selectedCharters={selectedCharters}
                text={charterText}
                handleOnChange={handleOnCharterTextChange}
                handleAssignCharter={handleAssignCharter}
                handleRemoveCharter={handleRemoveCharter}
                emptySelectedUser={() => setShowAddCharters(false)}
              />
            ) : (
              <>
                <div className="title-flex">
                  <FaIcons.FaArrowLeft
                    className="title-icon"
                    onClick={() => emptySelectedUser()}
                  />
                  <h3>Permission Review</h3>
                  <p style={{ visibility: "hidden" }}>Blank</p>
                </div>
                <UserPermissionReview
                  charters={selectedCharters}
                  level={permissionLevel}
                  charterAccess={allCharterAccess}
                  setLevel={handleOnPermissionChange}
                  setEdit={setShowAddCharters}
                  user={{
                    name: `${selectedUser.FirstName} ${selectedUser.LastName}`,
                    azureID: selectedUser.EmailAddress,
                  }}
                />
              </>
            )
          ) : (
            <SearchUser
              text={userText}
              handleOnChange={handleOnUserTextChange}
              setSelectedUser={setSelectedUser}
            />
          )}
        </div>
        <div className="bottom-bar">
          <div className="btns">
            {userNotEmpty && (
              <div
                onClick={() => handleConfirmAction()}
                className={`btn btn-llac-dark-${
                  completedCharterSelection || readyForSubmission
                    ? "green"
                    : "grey"
                }`}
              >
                Confirm {showAddCharters ? "Selection" : "Permission"}
              </div>
            )}
            <div
              className="btn btn-l4l-dark"
              onClick={() => setFormModal("addUserPermissionModal", false)}
            >
              Close
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddUserPermissionModal;
